module.exports = __webpack_public_path__ + "img/work3.0e39721a.png";